import React, { Suspense, lazy } from 'react';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { AppRouter } from './routes';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ChunkErrorBoundary from './components/ChunkErrorBoundary';
import SocketProvider from './components/SocketProvider';
import FloatingCountdownTimer from './components/ClassSessions/FloatingCountdownTimer';
import GlobalToolkitBar from './components/GlobalToolkit/GlobalToolkitBar';

const FeedbackFab = lazy(() => import('./components/Feedback/FeedbackFab'));

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
  },
});

function App() {
  const isIframeMode = new URLSearchParams(window.location.search).get('mode') === 'iframe';

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
        <ChunkErrorBoundary>
          <SocketProvider>
            <AppRouter />
            {!isIframeMode && (
              <Suspense fallback={null}>
                <FeedbackFab />
              </Suspense>
            )}
            <FloatingCountdownTimer />
            {!isIframeMode && <GlobalToolkitBar />}
          </SocketProvider>
        </ChunkErrorBoundary>
      </ThemeProvider>
    </Provider>
  );
}

export default App;

